/**
 * An config containing properties for tables
 */
var TableConfigBase = /** @class */ (function () {
    function TableConfigBase() {
    }
    return TableConfigBase;
}());
export { TableConfigBase };
//# sourceMappingURL=table-config-base.js.map